import * as React from "react";

const GraphicVideos: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="60" height="39" viewBox="0 0 60 39" fill="currentColor"><path fill="#DF1E27" d="M39,4.875 L39,34.125 C39,36.81742 36.81742,39 34.125,39 L4.875,39 C2.18258,39 0,36.81742 0,34.125 L0,4.875 C0,2.18258 2.18258,0 4.875,0 L34.125,0 C36.81641,0 39,2.18258 39,4.875 Z M58.5,6.44922 L58.5,32.54062 C58.5,35.13047 55.53742,36.64273 53.38226,35.15992 L42.25,27.49297 L42.25,11.50703 L53.38125,3.83297 C55.54453,2.34914 58.5,3.86953 58.5,6.44922 Z" transform="translate(.75)"/></svg>;
};

export default React.memo(GraphicVideos);
